import React from 'react';
import IconName from "../../svgLogo/SvgLogo";
import SearchBox from "./SearchBox";
import HeaderResponsive from "./HeaderResponsive";
import LogIn from "./LogIn";
import {Link} from "react-router-dom";
import TopBanner from "./TopBanner";

const Header = () => {
    return (
        <div id="header-box">
            <TopBanner/>
            <header id="header" className="xp-0">
                <div className="container position-relative">
                    <div id="header-wrapper-menu"
                         className="header-wrapper animate__animated animate__faster">
                        <div className="d-none d-lg-block">
                            <nav className="links-text">
                                <ul className="nav list-unstyled">
                                    <li className="nav-item logo-header"><Link to="/"><IconName name="sayman-logo"/></Link>
                                    </li>
                                    <li id="products-header" className="nav-item products-header"><span><IconName
                                        name="products"
                                        className="icon"/> محصولات<IconName
                                        name="expand_more" iconClassName="down-icon-header" className="icon"/></span>
                                    </li>
                                    <li className="nav-item"><a href="#"><IconName name="blog"
                                                                                   className="icon"/>وبلاگ</a>
                                    </li>
                                    <li className="nav-item seller"><Link to="/vendorHomePage"><IconName name="add_business"
                                                                                          className="icon"/>فروشنده
                                        شوید</Link>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        {/*responsive*/}
                        <div className="d-block d-lg-none">
                            <div className="d-flex align-items-center justify-content-center">
                                <div id="button-burger-menu" className="burger-menu xml-5">
                                    <IconName name="menu" className="icon"/>
                                </div>
                                <div className="logo">
                                    <a href="#"><IconName name="logo" className="icon"/></a>
                                </div>
                            </div>
                        </div>
                        {/*end responsive*/}

                        <div className="icons-header">
                            <ul className="nav list-unstyled">
                                <li id="search-icon-header" className="nav-item search-icon-header search-btn-header">
                                    <IconName name="search" className="icon"/>
                                </li>
                                <li className="nav-item cart-header d-none d-lg-block xmt-2">
                                    <a href="#">
                                    <IconName name="cart"/>
                                    <div className="number-cart position-absolute persian-number">1</div>
                                    </a>
                                </li>
                                <li className="nav-item login-header position-relative">
                                    <div className="d-none d-lg-block log-in-btn-toggle">
                                        <span>ورود </span><IconName name="expand_more" className="icon"
                                                                    iconClassName="down-icon-log-in"/>
                                    </div>
                                    <div className="d-block d-lg-none login-button-responsive-header log-in-btn-toggle">
                                        <img src="./assets/header-img/ic_user.png" alt="user" className="img-fluid"/>
                                    </div>
                                    <LogIn/>
                                </li>
                            </ul>

                        </div>
                    </div>

                    {/*startDropDownMenu*/}
                    <div className="d-none d-lg-block">
                        <div id="dropdown-box-header"
                             className="animate__animated animate__fadeOut animate__faster header-menu-dropdown xpt-4 position-absolute">
                            <nav className="icon-links-header xpr-4 xpl-4 position-relative">

                                <div className="swiper header-swiper">
                                    <ul className="swiper-wrapper nav nav-tabs" id="myTab" role="tablist">
                                        <li className="nav-item swiper-slide" role="presentation">
                                            <a href="#" className="nav-link active" id="nav-phone-tab"
                                               data-bs-toggle="tab"
                                               data-bs-target="#nav-phone" role="tab"
                                               aria-controls="nav-phone" aria-selected="true">
                                                <IconName name="phone" className="icon"/>
                                                گوشی موبایل
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide" role="presentation">
                                            <a href="#" className="nav-link" id="nav-laptop-tab" data-bs-toggle="tab"
                                               data-bs-target="#nav-laptop" role="tab" aria-controls="nav-laptop"
                                               aria-selected="false">
                                                <IconName name="laptop" className="icon"/>
                                                تبلت و لپ تاپ
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#" className="nav-link" id="nav-watch-tab" data-bs-toggle="tab"
                                               data-bs-target="#nav-watch" role="tab" aria-controls="nav-watch"
                                               aria-selected="false">
                                                <IconName name="watch" className="icon"/>
                                                ساعت هوشمند
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#" className="nav-link" id="nav-home-tab" data-bs-toggle="tab"
                                               data-bs-target="#nav-home" role="tab" aria-controls="nav-home"
                                               aria-selected="false">
                                                <IconName name="home" className="icon"/>
                                                خانه هوشمند
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="tv" className="icon"/>
                                                تلویزیون هوشمند
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="controller" className="icon"/>
                                                کنسول بازی
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="battery_charging_full" className="icon"/>
                                                پاور بانک
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="headphone" className="icon"/>
                                                لوازم صوتی
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="memory" className="icon"/>
                                                هارد و حافظه
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="cable" className="icon"/>
                                                لوازم جانبی
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="battery_charging_full" className="icon"/>
                                                پاور بانک
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="watch" className="icon"/>
                                                ساعت هوشمند
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="laptop" className="icon"/>
                                                تبلت و لپ تاپ
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="tv" className="icon"/>
                                                تلویزیون هوشمند
                                            </a>
                                        </li>
                                        <li className="nav-item swiper-slide">
                                            <a href="#">
                                                <IconName name="phone" className="icon"/>
                                                گوشی موبایل
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="more-icon-header-slider-next">
                                        <a href="#" className="link-header-button-next"><IconName name="chevron_left"
                                                                                                  className="icon"/></a>
                                    </div>
                                    <div className="more-icon-header-slider-prev">
                                        <a href="#" className="link-header-button-prev"><IconName name="chevron_left"
                                                                                                  className="icon"/></a>
                                    </div>
                                </div>

                            </nav>
                            <nav className="list-links-header">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-lg-9 col-xxl-10 tab-content" id="nav-tabContent">
                                            <div className="links-header tab-pane fade show active" id="nav-phone"
                                                 role="tabpanel" aria-labelledby="nav-phone-tab">
                                                <div className="row">
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><Link className="active" to="/products">همه گوشی ها</Link></li>
                                                            <li><Link to="/products">اپل</Link></li>
                                                            <li><a href="#">سامسونگ</a></li>
                                                            <li><a href="#">هوآوی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">سونی</a></li>
                                                            <li><a href="#">ال جی</a></li>
                                                            <li><a href="#">اچ تی سی</a></li>
                                                            <li><a href="#">نوکیا</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">آلکاتل</a></li>
                                                            <li><a href="#">موتورولا</a></li>
                                                            <li><a href="#">وان پلاس</a></li>
                                                            <li><a href="#">مایکروسافت</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">آنر</a></li>
                                                            <li><a href="#">شیائومی</a></li>
                                                            <li><a href="#">گوگل</a></li>
                                                            <li><a href="#">ال جی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">سونی</a></li>
                                                            <li><a href="#">ال جی</a></li>
                                                            <li><a href="#">اچ تی سی</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>

                                            {/*laptop*/}
                                            <div className="links-header tab-pane fade" id="nav-laptop"
                                                 role="tabpanel" aria-labelledby="nav-laptop-tab">
                                                <div className="row">
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a className="active" href="#">همه لپ تاپ ها</a></li>
                                                            <li><a href="#">1اپل</a></li>
                                                            <li><a href="#">سامسونگ1</a></li>
                                                            <li><a href="#">1هوآوی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">1سونی</a></li>
                                                            <li><a href="#">1ال جی</a></li>
                                                            <li><a href="#">1اچ تی سی</a></li>
                                                            <li><a href="#">نوکیا1</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">1آلکاتل</a></li>
                                                            <li><a href="#">1موتورولا</a></li>
                                                            <li><a href="#">1وان پلاس</a></li>
                                                            <li><a href="#">مایکروسافت1</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">آنر1</a></li>
                                                            <li><a href="#">شیائومی1</a></li>
                                                            <li><a href="#">گوگل1</a></li>
                                                            <li><a href="#">1ال جی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">سونی1</a></li>
                                                            <li><a href="#">ال جی1</a></li>
                                                            <li><a href="#">1اچ تی سی</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*laptop*/}

                                            {/*watch*/}
                                            <div className="links-header tab-pane fade" id="nav-watch"
                                                 role="tabpanel" aria-labelledby="nav-watch-tab">
                                                <div className="row">
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a className="active" href="#">همه ساعت ها</a></li>
                                                            <li><a href="#">1اپل</a></li>
                                                            <li><a href="#">سامسونگ1</a></li>
                                                            <li><a href="#">1هوآوی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">1سونی</a></li>
                                                            <li><a href="#">1ال جی</a></li>
                                                            <li><a href="#">1اچ تی سی</a></li>
                                                            <li><a href="#">نوکیا1</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">1آلکاتل</a></li>
                                                            <li><a href="#">1موتورولا</a></li>
                                                            <li><a href="#">1وان پلاس</a></li>
                                                            <li><a href="#">مایکروسافت1</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">آنر1</a></li>
                                                            <li><a href="#">شیائومی1</a></li>
                                                            <li><a href="#">گوگل1</a></li>
                                                            <li><a href="#">1ال جی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">سونی1</a></li>
                                                            <li><a href="#">ال جی1</a></li>
                                                            <li><a href="#">1اچ تی سی</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*watch*/}
                                            {/*home*/}
                                            <div className="links-header tab-pane fade" id="nav-home"
                                                 role="tabpanel" aria-labelledby="nav-home-tab">
                                                <div className="row">
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a className="active" href="#">همه خانه ها</a></li>
                                                            <li><a href="#">1اپل</a></li>
                                                            <li><a href="#">سامسونگ1</a></li>
                                                            <li><a href="#">1هوآوی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">1سونی</a></li>
                                                            <li><a href="#">1ال جی</a></li>
                                                            <li><a href="#">1اچ تی سی</a></li>
                                                            <li><a href="#">نوکیا1</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">1آلکاتل</a></li>
                                                            <li><a href="#">1موتورولا</a></li>
                                                            <li><a href="#">1وان پلاس</a></li>
                                                            <li><a href="#">مایکروسافت1</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">آنر1</a></li>
                                                            <li><a href="#">شیائومی1</a></li>
                                                            <li><a href="#">گوگل1</a></li>
                                                            <li><a href="#">1ال جی</a></li>
                                                        </ul>
                                                    </div>
                                                    <div className="col-lg-2 px-0">
                                                        <ul className="list-unstyled">
                                                            <li><a href="#">سونی1</a></li>
                                                            <li><a href="#">ال جی1</a></li>
                                                            <li><a href="#">1اچ تی سی</a></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*home*/}
                                        </div>
                                        <div className="col-lg-3 col-xxl-2 px-0">
                                            <div className="shop-info-header">
                                                <ul className="list-unstyled">
                                                    <li><a href="#">
                                                        <IconName name="add_shopping_cart" className="icon"/>
                                                        راهنمای خرید
                                                    </a></li>
                                                    <li><a href="#">
                                                        <IconName name="help_outline" className="icon"/>
                                                        پرسش های متداول
                                                    </a></li>
                                                    <li><a href="#">
                                                        <IconName name="payments" className="icon"/>
                                                        شیوه های پرداخت
                                                    </a></li>
                                                    <li><a href="#">
                                                        <IconName name="support_agent" className="icon"/>
                                                        تماس با ما
                                                    </a></li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                    {/*endDropDownMenu*/}
                    <SearchBox/>
                </div>
            </header>

            <div className="d-block d-lg-none header-dropdown-responsive">
                <HeaderResponsive/>
            </div>
        </div>
    );
};

export default Header
